/**
 * Web does not support Haptic feedback
 */
export default {
    press: () => {},
    longPress: () => {},
    success: () => {},
    error: () => {},
};
